import React from 'react';
import { PropTypes } from 'prop-types';
import { useTranslation } from 'react-i18next';
import { map } from 'lodash';
import { TableCell, TableHead, TableRow } from '@mui/material';
import TableContainer from '@mui/material/TableContainer';
import { Table, TableSection } from '../Table';
import CustomerRow from './CustomerRow';

export const CustomerTable = ({ customers, merchantsRouteInfo, customersRouteInfo }) => {
  const { t } = useTranslation();

  return (
    <TableContainer sx={{ paddingTop: '24px' }}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>{t('onboard.customer.fields.companyName')}</TableCell>
            {merchantsRouteInfo && <TableCell>{t('onboard.customer.fields.merchantId')}</TableCell>}
            <TableCell>{t('onboard.customer.fields.regNumber')}</TableCell>
            <TableCell>{t('onboard.customer.fields.status')}</TableCell>
            <TableCell>{t('onboard.customer.fields.country')}</TableCell>
            <TableCell>{t('onboard.customer.fields.creditLimit')}</TableCell>
          </TableRow>
        </TableHead>
        <TableSection emptyComponent={t('onboard.customer.listView.empty')}>
          {map(
            customers,
            ({ customer }) =>
              customer && (
                <CustomerRow
                  customer={customer}
                  key={customer.id}
                  customersRouteInfo={customersRouteInfo}
                  merchantsRouteInfo={merchantsRouteInfo}
                />
              ),
          )}
        </TableSection>
      </Table>
    </TableContainer>
  );
};

CustomerTable.propTypes = {
  customers: PropTypes.object,
  merchantsRouteInfo: PropTypes.object,
  customersRouteInfo: PropTypes.object.isRequired,
};
